import React, { createContext, useContext } from "react";
import { createMongoAbility } from "@casl/ability";
import { createContextualCan } from "@casl/react";
import { Auth } from "./Auth";
type PermList = string[];
export const build = (permList: PermList) => {
  const ret = [] as NonNullable<Parameters<typeof createMongoAbility>[0]>;
  for (const perm of permList) {
    const mongoAb = {} as (typeof ret)[number];
    const deny = perm.includes("_DENY");
    let raw = perm;
    if (deny) {
      mongoAb.inverted = true;
      raw = perm.replace("_DENY", "");
    }
    const [subject, action] = raw.split(".");
    mongoAb.subject = subject!;
    mongoAb.action = action!;
    ret.push(mongoAb);
  }
  return ret;
};
export const defineAbilityFor = (permList: PermList) => {
  return createMongoAbility(build(permList));
};
export type Ability = ReturnType<typeof defineAbilityFor>;
export const AbilityContext = createContext<Ability>(defineAbilityFor([]));
export const Can = createContextualCan(AbilityContext.Consumer);
export const PermissionsProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const user = useContext(Auth);
  const isAdmin = user?.isAdmin;
  const ability = defineAbilityFor(user?.profile.publicServantProfile?.accessRules ?? []);
  if (isAdmin) {
    ability.can = () => true;
    ability.cannot = () => false;
  }
  return <AbilityContext.Provider value={ability} data-sentry-element="unknown" data-sentry-component="PermissionsProvider" data-sentry-source-file="Permissions.tsx">{children}</AbilityContext.Provider>;
};
export const useAbility = (): Ability => {
  const ability = useContext(AbilityContext);
  if (!ability) {
    throw new Error("useAbility must be used within a PermissionsProvider");
  }
  return ability;
};